// src/components/FlightAlerts/handler/apiError.helper.ts

/**
 * Extracts the backend's DashError `code` (e.g. "OT_003", "RC_002") from a failed axios call.
 * Duck-typed rather than `axios.isAxiosError` — importing `axios` here breaks every test that
 * mocks `api.service.ts`'s axios usage away (this repo's Jest/CRA transform can't parse the
 * installed axios version's ESM entry point; see FlightAlerts.test.tsx for the full story).
 */
export const getDashErrorCode = (error: unknown): string | undefined => {
  if (typeof error !== "object" || error === null || !("response" in error)) {
    return undefined;
  }
  const response = (error as { response?: unknown }).response;
  if (typeof response !== "object" || response === null || !("data" in response)) {
    return undefined;
  }
  const data = (response as { data?: unknown }).data;
  if (typeof data !== "object" || data === null || !("code" in data)) {
    return undefined;
  }
  const code = (data as { code?: unknown }).code;
  return typeof code === "string" ? code : undefined;
};
